<template>
    <div style="width: 100%; margin: 0 auto; background: #f5f5f5; margin-top: 0.7rem">
        <div class="container" v-if="!uploadSuccessShow">
            <div style="font-size: 16px; margin-bottom: 0.16rem;" v-if="activityTypeQuery != 2">
                <el-icon @click="router.back()">
                    <Back />
                </el-icon><span style="padding-left: 10px;color: #333333 !important;">填写报名信息</span>
            </div>
            <div style="margin: 0px 5px;" v-if="activityTypeQuery != 2">
                <span style="color: red;">*</span>
                <span style="font-size: 14px; color: #333333 !important;">工程文件</span>
            </div>
            <div v-if="activityTypeQuery != 2">
                <div style="margin: 10px 0;" v-if="!uploadFile">
                    <div @click="handleUpload"
                        style="border: 1px #3fa4ed solid;color: #3fa4ed;padding: 5px 10px; text-align: center; border-radius: 5px;cursor: pointer; width: 150px;height: 30px;">
                        <el-icon>
                            <Upload />
                        </el-icon>
                        <span>点击上传</span>
                    </div>
                </div>
                <div class="sliderBox" v-else>
                    <div style="font-size: 0.16rem; color: #333333; font-weight: bold">
                        {{ uploadFile.title }}.{{ uploadFile.fileExt }}
                    </div>
                    <div style="margin-top: 0.06rem">
                        <el-progress :percentage="uploadFile.progress" :format="progressValue" />
                    </div>
                </div>
            </div>

            <el-form ref="ruleFormRef" v-loading="loadingImag" :model="ruleForm" label-width="100px" :rules="rules"
                class="demo-ruleForm" :size="formSize" status-icon label-position="left">
                <!-- <el-form-item label="选择类型" v-if="activityTypeQuery == 2">
                    <template #label>
                        <div style="margin-top:4px;display:flex;">
                            <div style="color: red;">*</div>
                            <div>选择类型</div>
                        </div>
                    </template>
                    <el-radio-group v-model="types_" @change="radioChange">
                        <el-radio value="1" size="large">视频文件</el-radio>
                        <el-radio value="2" size="large">图片文件</el-radio>
                    </el-radio-group>
                </el-form-item> -->
                <div v-if="types_ == '1'">
                    <el-form-item label="封面" prop="showImage">
                        <el-upload class="upload-demo" style="width: 100%;"
                            :before-upload="(file) => beforeUpload(file, 'image')" accept=".jpg,.png" drag
                            :action="upload_showImage" multiple :show-file-list="false" :on-success="onSuccessShowImage"
                            :limit="1" list-type="text" :file-list="ruleForm.files">
                            <!-- 默认显示的图片 -->
                            <el-image v-if="ruleForm.showImage" :src="ruleForm.showImage">
                                <template #error>
                                    <div class="image-slot">
                                        <el-icon class="el-icon--upload">
                                            <div style="
                        width: 0.2rem;
                        height: 0.2rem;
                        background: url(data:image/png;base64,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);
                        background-size: 100%;
                        background-repeat: no-repeat;
                      "></div>
                                        </el-icon>
                                        <div class="el-upload__text">
                                            <div style="font-size: 0.14rem; color: #333333">
                                                点击或拖拽文件到此处上传
                                            </div>
                                            <div style="font-size: 0.12rem; color: #86909c">
                                                图片尺寸至少302*180
                                            </div>
                                            <div style="font-size: 0.12rem; color: #86909c">
                                                支持JPG/PNG，不超过6MB
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </el-image>
                            <div v-else>
                                <el-icon class="el-icon--upload">
                                    <div style="
                    width: 0.2rem;
                    height: 0.2rem;
                    background: url(data:image/png;base64,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);
                    background-size: 100%;
                    background-repeat: no-repeat;
                  "></div>
                                </el-icon>
                                <div class="el-upload__text">
                                    <div style="font-size: 0.14rem; color: #333333">
                                        点击或拖拽文件到此处上传
                                    </div>
                                    <div style="font-size: 0.12rem; color: #86909c">
                                        图片尺寸至少302*180
                                    </div>
                                    <div style="font-size: 0.12rem; color: #86909c">
                                        支持JPG/PNG，不超过6MB
                                    </div>
                                </div>
                            </div>
                        </el-upload>
                    </el-form-item>
                    <el-form-item :label="activityTypeQuery == 2 ? '作品' : '预览视频'" prop="previewPath">
                        <el-upload class="upload-demo" style="width: 100%;"
                            :before-upload="(file) => beforeUpload(file, 'previewPath')" accept=".mp4,video/*" drag
                            :action="upload_showImage" multiple :show-file-list="false" :on-success="onSuccessPreview"
                            :onProgress="onProgress_" :limit="1" list-type="text" :file-list="ruleForm.files">
                            <!-- 默认显示的图片 -->
                            <video class="video" v-if="ruleForm.previewPath" :src="ruleForm.previewPath"></video>
                            <div v-else>
                                <div v-if="isProgress">
                                    <el-progress :percentage="isProgressNum" />
                                </div>
                                <div v-else>
                                    <el-icon class="el-icon--upload">
                                        <div style="
                    width: 0.2rem;
                    height: 0.2rem;
                    background: url(data:image/png;base64,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);
                    background-size: 100%;
                    background-repeat: no-repeat;
                  "></div>
                                    </el-icon>
                                    <div class="el-upload__text">
                                        <div style="font-size: 0.14rem; color: #333333">
                                            点击或拖拽文件到此处上传
                                        </div>
                                        <div style="font-size: 0.12rem; color: #86909c">
                                            {{ (route as any).query.activityType == 2 ? "请上传视频文件" : " 支持MP4，不超过200M" }}
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </el-upload>
                    </el-form-item>
                    <el-form-item label="标题" prop="title">
                        <el-input v-model="ruleForm.title" placeholder="请输入标题" maxlength="40" show-word-limit clearable />
                    </el-form-item>
                    <el-form-item label="视频简介" v-if="activityTypeQuery == 2">
                        <el-input v-model="ruleForm.content" type="textarea" :rows="2" placeholder="请输入视频简介"
                            maxlength="1000" show-word-limit clearable />
                    </el-form-item>
                </div>
                <div v-if="types_ == '2'">
                    <el-form-item label="图片" prop="typeImgageList">
                        <el-upload class="upload-demo" style="width: 100%;"
                            :before-upload="(file) => beforeUpload_(file, 'image')" v-model:file-list="typeImgageList_file"
                            accept=".jpg,.png,.jpeg" drag :action="upload_showImage" :multiple="false"
                            :show-file-list="false" :on-success="onSuccessShowImage_" :limit="3" list-type="text">
                            <div>
                                <el-icon class="el-icon--upload">
                                    <div
                                        style="width: 0.2rem;height: 0.2rem;background: url(data:image/png;base64,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);background-size: 100%;background-repeat: no-repeat;">
                                    </div>
                                </el-icon>
                                <div class="el-upload__text">
                                    <div style="font-size: 0.14rem; color: #333333">
                                        点击或拖拽文件到此处上传
                                    </div>
                                    <div style="font-size: 0.12rem; color: #86909c">
                                        请上传2MB-30MB大小图片
                                    </div>
                                    <div style="font-size: 0.12rem; color: #86909c">
                                        支持JPG/JPEG/PNG
                                    </div>
                                </div>
                            </div>
                        </el-upload>
                    </el-form-item>
                    <div style="color: rgb(240 108 35);padding-left: 9%;font-size: 14px;">
                        <span>最多上传3张图片，图片标题输入格式需注明【真实姓名+联系方式+拍摄设备型号】，请按要求填写</span>
                    </div>
                    <div class="sss"
                        style="display: flex;align-items: center;column-gap: 10px;margin-top: 16px;width: 100%;padding-bottom: 40px;padding-left: 9%;">
                        <div v-for="(item, index) in ruleForm.typeImgageList" :key="index" style="width: 33%;">
                            <el-form-item style="width: 100%;" :prop="'typeImgageList.' + index + '.title'"
                                :rules="[{ required: true, message: '标题不能为空', trigger: 'blur' }]">
                                <div style="flex:none;width: 100%;height: 200px;position: relative;">
                                    <el-image style="width: 100%; height: 100%;border-radius: 12px;background:#f5f5f5"
                                        :src="item.url" fit="scale-down" />
                                    <div style="position: absolute;right: -6px;top: -12px;font-size: 18px;"
                                        @click="deleteImg(index)">
                                        <el-icon>
                                            <CircleCloseFilled />
                                        </el-icon>
                                    </div>
                                    <el-input v-model.trim="item.title" show-word-limit maxlength="80"
                                        placeholder="请输入标题" />
                                </div>
                            </el-form-item>
                        </div>


                    </div>
                    <!-- <el-form-item label="标题" prop="title">
                        <el-input v-model="ruleForm.title" placeholder="请输入标题" maxlength="40" show-word-limit clearable />
                    </el-form-item> -->
                </div>
                <el-form-item label="分类" prop="typeIds" v-if="activityTypeQuery != 2">
                    <div style="display: flex; justify-content: space-between; width: 100%">
                        <!-- <el-input v-model="ruleForm.name" placeholder="*请选择分类一" /> -->
                        <el-select style="width: 100%" :max-collapse-tagIds="6" v-model="ruleForm.typeIds" collapse-tagIds
                            placeholder="*请选择" multiple>
                            <el-option-group v-for="group in options" :key="group.name" :label="group.name">
                                <el-option v-for="item in group.options" :key="item.id" :label="item.name"
                                    :value="item.id" />
                            </el-option-group>
                        </el-select>
                    </div>
                </el-form-item>
                <el-form-item label="标签" prop="tagIds" v-if="activityTypeQuery != 2">
                    <el-select class="tagType" style="width: 100%" v-model="ruleForm.tagIds" clearable multiple
                        :reserve-keyword="false" multiple-limit="10" filterable allow-create default-first-option
                        id="selecttagsId" placeholder="最多添加10个标签,每个标签最多10个字,按回车Enter创建标签" no-data-text=""
                        @input.native="handleInput">
                        <!-- <el-option v-for="item in tagIds" :key="item.value" :label="item.label"
							:value="item.label"></el-option> -->
                    </el-select>
                </el-form-item>
                <!-- <el-form-item label="标签" prop="tagIds">
					<el-input type="input" v-model="ruleForm.tagIds" placeholder="每个标签最多20个字，按回车Enter创建标签">
						<template #append>还可添加10个标签</template>
					</el-input>
				</el-form-item> -->
                <el-form-item label="作品定价" prop="selfPrice" v-if="activityTypeQuery != 2">
                    <div style="
              display: flex;
              flex-wrap: wrap;
              justify-content: space-between;
              width: 100%;
            ">
                        <div style="
                min-width: 300px;
                margin-right: 0.24rem;
                color: #86909c;
                margin-bottom: 0.08rem;
              ">
                            <div>个人授权价格</div>
                            <el-input oninput="value=value.replace(/[^\d.]/g, '')" min="1" v-model="ruleForm.selfPrice"
                                placeholder="请输入个人授权价格" clearable>
                                <template #append>元</template>
                            </el-input>
                        </div>
                        <div style="
                min-width: 300px;
                margin-right: 0.24rem;
                color: #86909c;
                margin-bottom: 0.08rem;
              ">
                            <div>企业授权价格</div>
                            <el-input v-model="ruleForm.enterPrice" oninput="value=value.replace(/[^\d.]/g, '')"
                                placeholder="请输入企业授权价格" clearable>
                                <template #append>元</template>
                            </el-input>
                        </div>
                        <div style="min-width: 300px; color: #86909c; margin-bottom: 0.08rem">
                            <div>企业Plus授权价格</div>
                            <el-input v-model="ruleForm.enterPlusPrice" oninput="value=value.replace(/[^\d.]/g, '')"
                                placeholder="请输入企业Plus授权价格" clearable>
                                <template #append>元</template>
                            </el-input>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="原创证明" v-if="activityTypeQuery != 2">
                    <el-upload class="upload-demo" :before-upload="(file) => beforeUpload(file, 'images')"
                        accept=".jpg,.png" drag :action="upload_showImage" multiple :on-success="onSuccessImages"
                        v-model:file-list="ruleForm.images" list-type="picture">
                        <el-icon class="el-icon--upload">
                            <div style="
                  width: 0.2rem;
                  height: 0.2rem;
                  background: url(data:image/png;base64,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);
                  background-size: 100%;
                  background-repeat: no-repeat;
                "></div>
                        </el-icon>
                        <div class="el-upload__text">
                            <div style="font-size: 0.14rem; color: #333333">
                                点击或拖拽文件到此处上传
                            </div>
                            <div style="font-size: 0.12rem; color: #86909c">
                                图片大小20KB-10MB
                            </div>
                        </div>
                        <!-- </div> -->
                    </el-upload>
                </el-form-item>
            </el-form>
            <div style="display: block;width: 100%;">
                <el-button plain type="primary" v-if="activityTypeQuery != 2" size="large"
                    style="min-width: 280px;font-size:16px;height:45px;" @click="router.back()">上一步</el-button>
                <el-button type="primary" size="large" style="min-width: 280px;font-size:16px;height:45px;"
                    @click="onSubmit(ruleFormRef)">提交审核</el-button>
            </div>
        </div>
        <div class="" v-if="uploadSuccessShow" style="height: 430px; width: 12rem;margin: 0px auto;padding: 40px 0 20px;">
            <div
                style="height:100%;background: #FFF;border-radius: 8px;display: flex;flex-direction: column;align-items: center;justify-content: center;">
                <img src="../../assets//success.png" style="width: 48px;height: 48px;" alt="" srcset="">
                <div style=" color: #333333; font-size: 14px;margin-top: 16px;"><span>上传成功</span></div>
                <div style="  color: #86909c; font-size: 14px;margin-top: 4px;"><span>{{ activityTypeQuery == 2 ?
                    "您的参赛作品上传成功，请勿重复上传" : "等待工作人员审核，审核成功后计入活动数量" }}</span></div>
                <div style="  color: #ff7726; font-size: 14px;margin-top: 4px;" v-if="activityTypeQuery != 2">
                    <span>可前往头像一我的素材一在审素材中查看审核状态</span>
                </div>
                <div style="display: flex;align-items: center;column-gap: 20px;margin-top: 24px;">
                    <div @click="backDetail"
                        style="width: 116px;height: 37px;text-align: center;line-height: 37px;border: 1px solid #2978FF;border-radius: 8px; color: #2978ff; font-size: 14px;cursor: pointer;">
                        <span>返回活动详情</span>
                    </div>
                    <div @click="jx" v-if="activityTypeQuery != 2"
                        style="width: 88px;height: 37px;text-align: center;line-height: 37px;background:#2978FF; border-radius: 8px; color: #FFF; font-size: 14px;cursor: pointer;">
                        <span>继续上传</span>
                    </div>
                    <div @click="examineBtn" v-if="activityTypeQuery == 2"
                        style="width: 115px;height: 37px;text-align: center;line-height: 37px;background:#2978FF; border-radius: 8px; color: #FFF; font-size: 14px;cursor: pointer;">
                        <span>查看我的作品</span>
                    </div>
                </div>
            </div>
        </div>

        <input class="layout-file" style="height: 0px" type="file" @change="handleFileChange" ref="inputer"
            accept=".zip,.rar,video/*" />
    </div>
</template>
<script lang="ts" setup>
import { useRouter } from "vue-router";
import { useRoute } from "vue-router";
import { ElMessage } from "element-plus";
import { ref, reactive, computed, onBeforeMount, onMounted, nextTick, watch } from "vue";
import { Axios } from "../../assets/js/ls_com_axios.js";
import uploadByPieces from "@/assets/js/uploadNew";
import { serverBaseUrl } from "../../assets/js/ls_tgServerUrls.js";

import type { FormInstance, FormRules } from "element-plus";
import { types } from "util";
interface RuleForm {
    name: string;
    radio: number;
    enterPlusPrice: string | number;
    selfPrice: string | number;
    enterPrice: string | number;
    title: string;
    previewPath: string;
    tagIds: [];
    typeIds: [];
    images: [];
    images2: []
    files: [];
    file: any;
    filePath: string
    fileName: string
    activityId: string | number | undefined
}
const route = useRoute();
const router = useRouter();
const uploadFile = ref<any>(null)
const uploadSuccessShow = ref(false);
const activityTypeQuery: any = ref(route.query.activityType);
const allowedExtensions = ref([".rar", ".zip", ".mp4"])
const inputer = ref<any>(null)
const id = ref<number>()
const upload_showImage = ref(serverBaseUrl + "/file/upload");
const handleInput = () => {
    const selectId = document.querySelector("#selecttagsId");
    if (selectId) {
        selectId.setAttribute("maxLength", '10');
    }
};
const jx = () => {
    location.reload();
    uploadSuccessShow.value = false
}
const examineBtn = () => {
    router.push({
        path: "/allProduction",
        query: { id: route.query.id }
    })
}
handleInput();
const isProgress = ref(false);
const isProgressNum = ref(0); //进度条
const onProgress_ = (e: any) => {
    isProgress.value = true;
    isProgressNum.value = Math.ceil(e.percent);
    if (isProgressNum.value == 100) {
        isProgress.value = false;
    }
}
const formSize = ref("default");
const ruleFormRef = ref<FormInstance>();
const isSwitch = ref(false);
const types_ = ref("1");
const backDetail = () => {
    (route as any).query.activityType == 3 ? router.push({
        path: "/drawList",
        query: { id: route.query.activityId }
    }) :
        router.push({
            path: "/ShowActivity",
            query: { id: route.query.id }
        });
}
const getInfo = function () {
    Axios("get", "/system/activity/" + route.query.id, null, false, function (res: any) {
        if (res.data.code == 200) {
            types_.value = String(res.data.data.otherType);
        } else {
            ElMessage.error(res.data.message);
        }
    });
};
(route as any).query.activityType == 2 && getInfo()
const progressValue = (percentage) =>
    percentage === 100 ? "100%" : `${percentage}%`;
const handleFileChange = (fileArray: any) => {
    const timestamp = Date.now();
    let files = []; // 将 const 改为 let
    if (fileArray && Array.isArray(fileArray)) {
        files = fileArray;
    } else {
        files = Array.from(inputer.value.files);
    }
    if (files[0]) {
        const file = files[0]
        if (
            allowedExtensions.value.indexOf(
                file.name.substring(file.name.lastIndexOf(".")).toLocaleLowerCase()
            ) == -1
        ) {
            ElMessage.warning("格式不正确");
            return;
        }
        const fileName = file.name;
        const guid = newGuid();
        const fileData = {
            guid: guid,
            progress: 0,
            materialType: 'VIDEO',
            size: file.size,
            title: fileName.substring(0, fileName.lastIndexOf(".")),
            fileExt: fileName.substring(fileName.lastIndexOf(".") + 1),
            isUploading: true, // 添加上传状态标志
        };
        uploadFile.value = fileData
        console.info(fileData)
        uploadByPieces(
            timestamp,
            file,
            5,
            3,
            (res: any) => {
                if (uploadFile.value.isUploading) {
                    // 处理上传成功逻辑
                    const params = {
                        title: fileName.substring(0, fileName.lastIndexOf(".")),
                        fileExt: fileName.substring(fileName.lastIndexOf(".") + 1),
                        filePath: res.data.url,
                        materialType: 'VIDEO',
                    };
                    Axios("post", "/fodder", params, false, (resp: any) => {
                        if (resp.data.code !== 200) {
                            ElMessage.error(resp.data.msg);
                        } else {
                            isSwitch.value = true;
                            uploadFile.value.id = resp.data.data.id
                            ruleForm.value.title = resp.data.data.title
                            ruleForm.value.id = resp.data.data.id
                            ruleForm.value.filePath = resp.data.data.filePath
                        }
                    });
                }
            },
            (p: number) => {
                if (uploadFile.value.isUploading) {
                    uploadFile.value.progress = p;
                }
            },
            (error: any) => {
                console.error(error);
            }
        );
    }
}
const handleUpload = () => {
    inputer.value.value = "";
    inputer.value.click();
}
const newGuid = () => {
    let guid = "";
    for (let i = 1; i <= 32; i++) {
        const n = Math.floor(Math.random() * 16.0).toString(16);
        guid += n;
        if (i === 8 || i === 12 || i === 16 || i === 20) guid += "-";
    }
    return guid;
}
const options = ref<any>([]);
Axios("get", "/fodder/video-types", {}, false, function (res: any) {
    const tree = buildTree(res.data.data);
    options.value = tree;
});

function buildTree(materials: any) {
    const tree = {} as any;
    materials.forEach((material: any) => {
        const id = material.id;
        const parentId = material.parentId;

        if (!tree[id]) {
            tree[id] = { ...material, options: [] };
        } else {
            tree[id] = { ...material, options: tree[id].options };
        }

        if (!tree[parentId]) {
            tree[parentId] = { options: [] };
        }
        tree[parentId].options.push(tree[id]);
    });

    return tree[0].options;
}

let ruleForm = ref<any>({
    enterPlusPrice: "",
    selfPrice: "",
    enterPrice: "",
    previewPath: "",
    tagIds: [],
    title: "",
    typeIds: [],
    images: [],
    images2: [],
    file: undefined,
    filePath: '',
    fileName: '',
    files: [],
    activityId: route.query.id?.toString(),
    name: "",
    radio: 0,
    content: "",
    typeImgageList: []
});
const loadingImag = ref(false)
const rules = reactive<any>({
    showImage: [{ required: true, message: "请选择封面", trigger: "blur" }],
    previewPath: [{ required: (route as any).query.activityType == 2 ? true : false, message: (route as any).query.activityType == 2 ? "请上传工程文件" : "请选择预览视频", trigger: "blur" }],
    enterPlusPrice: [
        { required: true, message: "请输入企业Plus授权价格", trigger: "blur" }, {
            validator: (rule, value, cb) => {
                if (value.indexOf(".") != -1) {
                    return cb(new Error('请输入正整数'));
                }
                return cb();
                // if (value != 0) {
                //     //合法的邮箱
                //     return cb();
                // }
                //邮箱不合法
                // cb(new Error('金额必须大于零！'));
            }, trigger: 'blur'
        }
    ],
    selfPrice: [{ required: true, message: "请输入作品定价", trigger: "blur" }, {
        validator: (rule, value, cb) => {
            if (value.indexOf(".") != -1) {
                return cb(new Error('请输入正整数'));
            }
            return cb();
            // if (value != 0) {
            //     return cb();
            // }
            // //邮箱不合法
            // cb(new Error('金额必须大于零！'));
        }, trigger: 'blur'
    }],
    enterPrice: [
        { required: true, message: "请输入企业授权价格", trigger: "blur" }, , {
            validator: (rule, value, cb) => {
                if (value.indexOf(".") != -1) {
                    return cb(new Error('请输入正整数'));
                }
                return cb();
                // if (value != 0) {
                //     return cb();
                // }
                //邮箱不合法
                // cb(new Error('金额必须大于零！'));
            }, trigger: 'blur'
        }
    ],
    tagIds: [{ required: true, message: "请输入标签", trigger: "blur" }],
    typeIds: [{ required: true, message: "请输入分类", trigger: "blur" }],
    title: [{ required: true, message: "请输入标题", trigger: "blur" }],
    typeImgageList: [{ required: true, message: "请上传作品" }],
});
const onSubmit = async (formEl: FormInstance | undefined) => {
    if (!formEl) return;
    let tagIdsString = "";
    if (ruleForm.value.tagIds.length != 0) {
        for (let i = 0; i < ruleForm.value.tagIds.length; i++) {
            if (i == ruleForm.value.tagIds.length - 1) {
                tagIdsString = tagIdsString + ruleForm.value.tagIds[i];
            } else {
                tagIdsString = tagIdsString + ruleForm.value.tagIds[i] + ",";
            }
        }
    }
    if (!isSwitch.value && activityTypeQuery.value != 2) {
        ElMessage({
            message: "请上传工程文件",
            type: "error",
        });
        return;
    }
    if (types_.value == '1' && !ruleForm.value.showImage) {
        ElMessage({
            message: "请上传封面",
            type: "error",
        });
        return;
    }
    // if (!ruleForm.previewPath && activityTypeQuery.value != 2) {
    //     ElMessage({
    //         message: "请上传预览视频",
    //         type: "error",
    //     });
    //     return;
    // }
    await formEl.validate((valid, fields) => {
        if (valid) {
            let data = JSON.parse(JSON.stringify(ruleForm.value));
            data.typeIds = Array.isArray(data.typeIds)
                ? data.typeIds.join(",")
                : data.typeIds;
            data.tagIds = tagIdsString;
            data.tagIds = Array.isArray(data.tagIds)
                ? data.tagIds.join(",")
                : data.tagIds;
            data.materialType = "VIDEO"
            const urls = [] as any[];
            if (data.images.length != 0) {
                data.images.forEach((item: any) => {
                    urls.push(item.url);
                });
            }

            let images = [...urls, ...ruleForm.value.images2];
            let new_images: any = [];
            if (images.length != 0) {
                images.forEach((item, index) => {
                    if (item.indexOf("blob:") === -1) {
                        new_images.push(item);
                    }
                });
            }
            data.images = new_images;
            if (types_.value == '2' && (route as any).query.activityType == 2) {
                data.imagesOther = JSON.stringify(data.typeImgageList);
                data.materialType = types_.value == '2' ? "IMAGE" : "VIDEO"; // 1视频 2图片
            }
            Axios((route as any).query.activityType == 2 ? "post" : "put", (route as any).query.activityType == 2 ? "/system/activity-join/offlineAdd" : "/fodder", (route as any).query.activityType == 3 ? Object.assign(data, {
                activityId: route.query.activityId,
                taskId: route.query.id,
            }) : data, false, (res) => {
                if (res.data.code == 200) {
                    uploadSuccessShow.value = true;
                } else {
                    ElMessage.error(res.data.msg);
                }
            });
        }
    });
};
const onSuccessImages = (res) => {
    if (res.code == 200) {
        ruleForm.value.images2.push(res.data.url);
        ElMessage({
            message: "上传成功",
            type: "success",
        })
    } else {
        ElMessage({
            message: "上传失败",
            type: "error",
        });
    }
};
const deleteImg = (index: number) => {
    ruleForm.value.typeImgageList = ruleForm.value.typeImgageList.filter((item, i) => i != index);
    typeImgageList_file.value = typeImgageList_file.value.filter((item, i) => i != index);
}
const onSuccessShowImage = (res) => {
    ruleForm.value.files = [];
    if (res.code == 200) {
        ruleForm.value.showImage = res.data.url;
        ElMessage({
            message: "上传成功",
            type: "success",
        });
    } else {
        ElMessage({
            message: "上传失败",
            type: "error",
        });
    }
};
// const typeImgageList: any = ref([]);
const typeImgageList_file: any = ref([]);
const radioChange = (e: any) => {
    types_.value = e;
    ruleForm.value = {
        enterPlusPrice: "",
        selfPrice: "",
        enterPrice: "",
        previewPath: "",
        tagIds: [],
        title: "",
        typeIds: [],
        images: [],
        images2: [],
        file: undefined,
        filePath: '',
        fileName: '',
        files: [],
        activityId: route.query.id?.toString(),
        name: "",
        radio: 0,
        content: "",
        typeImgageList: []
    };
    typeImgageList_file.value = [];
}
const onSuccessShowImage_ = (res: any) => {
    if (res.code == 200) {
        ruleForm.value.typeImgageList.push({
            url: res.data.url,
            title: ""
        });
        (ruleFormRef as any).value.validate(() => { })
        ElMessage({
            message: "上传成功",
            type: "success",
        });
    } else {
        ElMessage({
            message: "上传失败",
            type: "error",
        });
    }
    loadingImag.value = false;
};
const onSuccessPreview = (res) => {
    ruleForm.value.files = [];
    if (res.code == 200) {
        ruleForm.value.previewPath = res.data.url;
        ElMessage({
            message: "上传成功",
            type: "success",
        });
    } else {
        ElMessage({
            message: "上传失败",
            type: "error",
        });
    }
};
const beforeUpload = (file, type) => {

    let maxSize = 6;
    if (type == "previewPath") {
        ruleForm.value.previewPath = "";
        maxSize = 200;
    }
    if (type == "images") {
        maxSize = 10;
    }
    if ((route as any).query.activityType == 2 && type == "previewPath") {
        return true
    }
    const isLt = file.size / 1024 / 1024 < maxSize;
    if (!isLt) {
        ElMessage({
            message: `上传文件大小不能超过${maxSize}MB!`,
            type: "error",
        });
        return false;
    }
    return true;
};
const beforeUpload_ = async (file, type) => {
    let maxSize = 30;
    let minSize = 2;
    const isLt = file.size / 1024 / 1024 < maxSize;
    const isLt_ = file.size / 1024 / 1024 < minSize;
    if (isLt_) {
        ElMessage({
            message: `上传文件大小不能小于${minSize}MB!`,
            type: "error",
        });
        return false;
    }
    if (!isLt) {
        ElMessage({
            message: `上传文件大小不能超过${maxSize}MB!`,
            type: "error",
        });
        return false;
    }
    loadingImag.value = true;
    return true;
};
// const imgSize = (file) => {
//     return new Promise((resolve, reject) => {
//         const image = new Image();
//         image.onload = () => {
//             if (image.width >= 3000 && image.height >= 3000) {
//                 resolve({
//                     code: 0
//                 })
//             } else {
//                 ElMessage.error(`上传图片尺寸必须是3000*3000`);
//                 reject({
//                     code: 400
//                 })
//             }
//         };
//         image.src = URL.createObjectURL(file);
//     })
// }
</script>
<style scoped lang="less">
@import url(/src/assets/css/com.css);

/deep/.el-form-item.is-success .el-input__suffix-inner {
    color: #67C23A !important;
}

/deep/.sss .el-form-item__content {
    margin-left: 0px !important;
}

/deep/.sss .el-form-item__error {
    display: none;
}

.container {
    width: 12rem;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    flex-wrap: wrap;
    background: #fff;
    padding: 30px;
}

.sliderBox {
    border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
    background: #f5f5f5;
    padding: 0.24rem 0.24rem 0.32rem;
    box-sizing: border-box;
    margin: 0.16rem 0 0.24rem;
}

.upload-demo {
    width: 2.02rem;
}

.dataBtn {
    width: 2.68rem;
    padding: 0.12rem 1.06rem;
    background: #c01a26;
    border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
    opacity: 1;
    text-align: center;
    font-size: 0.14rem;
    color: #fff;
    cursor: pointer;
}

.other {
    background: rgba(255, 96, 0, 0.2);
    border-radius: 0.28rem;
    opacity: 1;
    font-size: 0.14rem;
    color: #c01a26;
    padding: 0.1rem;
}

.video {
    width: 100%;
    height: 100%;
}

/deep/.el-form-item__label {
    /* width: 1.7rem!important; */
    color: #333333 !important;
    text-align: left !important;
}

/deep/.el-form-item--default {
    font-size: 0.14rem !important;
}

.shiping:before {
    content: "*";
    color: var(--el-color-danger);
    margin-right: 4px;
}

/deep/.el-upload-dragger {
    background: #f5f5f5;
    width: 3.02rem;
    padding-top: 0.38rem;
    padding-bottom: 0.38rem;
}

/deep/.el-upload-dragger .el-icon--upload {
    margin-bottom: 0 !important;
}

/deep/.el-popper {
    display: none !important;
}
</style>